import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../store';
import { env } from '../../utils/env';

/**
 * Base API configuration for RTK Query.
 * All API slices inject endpoints into this base API.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: env.API_ENDPOINT,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      if (env.API_KEY) {
        headers.set('x-api-key', env.API_KEY);
      }
      return headers;
    },
  }),
  tagTypes: ['Agent', 'Session', 'Analytics'],
  endpoints: () => ({}),
});
